if(typeof FN == 'undefined') FN = {};

FN.GitWebinars = {
  config: {
    selectors: {
      dateboxTimeClass: 'datebox__time',
      dateboxDateClass: 'datebox__date'
    }
  },
  
  timeInTimezone: function(timezone) {
    // using the "moment" library to convert webinar UTC time to user's local timezone
    var momentTime = moment(FN.GitWebinarsDate);
    var momentTimezone = (timezone === 'user') ? moment.tz.guess() : 'GMT';
    return {
      all: momentTime.tz(momentTimezone).format('h a z'),
      day: momentTime.tz(momentTimezone).format('dddd, MMM D'),
      hour: momentTime.tz(momentTimezone).format('h'),
      meridiem: momentTime.tz(momentTimezone).format('a'),
      timezone: momentTime.tz(momentTimezone).format('z')
    }
  },
  
  getTimeHtmlString: function(timeObject) {
    var html = '<span class="time">';
    html += '<span class="time--hour">' + timeObject.hour + '</span> &nbsp; ';
    html += '<span class="time--meridiem">' + timeObject.meridiem + '</span> &nbsp; ';
    html += '<span class="time--timezone">' + timeObject.timezone + '</span>';
    html += '</span>';
    return html;
  },
  
  displayLocalTime: function() {
    if(typeof FN.GitWebinarsDate == 'undefined') return;

    var webinarLocalTime = FN.GitWebinars.timeInTimezone('user');
    var webinarUTCTime = FN.GitWebinars.timeInTimezone('utc');
    
    var html = FN.GitWebinars.getTimeHtmlString(webinarLocalTime);
    html += FN.GitWebinars.getTimeHtmlString(webinarUTCTime);

    $('.'+FN.GitWebinars.config.selectors.dateboxTimeClass).html(html);
    $('.'+FN.GitWebinars.config.selectors.dateboxDateClass).html(webinarLocalTime.day);
  },
  
  startUnderwaterAnimations: function() {
    var animationItems = [
      { 'container': '#underwater--octopus', 'path': 'underwater-octopus.json' },
      { 'container': '#underwater--submarine', 'path': 'underwater-submarine.json' },
      { 'container': '#underwater--fish-01', 'path': 'underwater-fish-01.json' },
      { 'container': '#underwater--fish-02', 'path': 'underwater-fish-02.json' },
      { 'container': '#underwater--fish-03', 'path': 'underwater-fish-01.json' },
      { 'container': '#underwater--fish-04', 'path': 'underwater-fish-02.json' },
      { 'container': '#underwater--fish-05', 'path': 'underwater-fish-02.json' }
    ];
    
    for(var i=0; i<animationItems.length; i++){
      lottie.loadAnimation({
        container: $(animationItems[i]['container'])[0],
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: FN.config.urls.base + "assets/specials/git-webinars/" + animationItems[i]['path']
      });
    }
  }
}






$(document).ready(function(){
  /*********** Configure Analytics Event Tracking */
  var contentAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.body--special .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'webinar', 'eventAction': 'signup', 'eventLabelSuffix': 'learn-git-webinar' }
    }
  ];
  FN.analytics.addConfiguredEvents(contentAnalyticsEvents);

  /************* Display Correct User Timezone */
  FN.GitWebinars.displayLocalTime();

  /************* Start "Underwater Seaworld" Animations */
  FN.GitWebinars.startUnderwaterAnimations();

  /*************  Handle successful signup */
  $(document).on('FN.newsletter:success', function (event, context) {
    // Get normal HTML element from jQuery element
    var form = context.formElement[0];
    // Check the form ID to make sure this is the correct event
    if (form.id === 'webinar-form') {
      var success = document.querySelector('.signup-success');
      success.classList.add('visible');
      form.classList.add('hidden');
    }
  });
});
